import { render, staticRenderFns } from "./TripleAughtDesign.vue?vue&type=template&id=3f19d5bc&"
import script from "./TripleAughtDesign.vue?vue&type=script&lang=js&"
export * from "./TripleAughtDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports